import { gql } from '@apollo/client'

export const findAllLoadCustGQL = gql`
  query findAllLoadCust {
    findAllLoadCust {
      _id
      name
      prevKEPCOContractedPower
      re100Opt
      loadOpt
    }
  }
`

export const UpdateLoadcustGQL = gql`
  mutation updateLoadCust($val: UpdateLoadCustInput!) {
    updateLoadCust(updateLoadCustInput: $val) {
      _id
    }
  }
`

export const CreateLoadcustGQL = gql`
  mutation createLoadCust($val: CreateLoadCustInput!) {
    createLoadCust(createLoadCustInput: $val) {
      _id
    }
  }
`

export const DeleteLoadcustGQL = gql`
  mutation deleteLoadCust($val: String!) {
    deleteLoadCust(_id: $val) {
      _id
    }
  }
`

export const findOneLoadcusGQL = gql`
  query findOneLoadCust($val: String!) {
    findOneLoadCust(_id: $val) {
      _id
      name
      custType
      KEPCOPlanType {
        _id
        name
      }
      prevKEPCOContractedPower
      re100Opt
      loadOpt
      patternList {
        patternId
        months
      }
    }
  }
`

export const findAllLoadPatternGQL = gql`
  query findAllCustomerAPI {
    findAllCustomerAPI {
      _id
      name
      power_user_seq
      dt
      hr
      ndata
      usage_power
      meta_power
    }
  }
`

export const findAllLoadPatternNamesGQL = gql`
  query findAllCustomerAPINames {
    findAllCustomerAPINames {
      _id
      name
    }
  }
`

export const findLoadPatternDataGQL = gql`
  query findAllCustomerAPI($val: FindAllCustomerAPIInput) {
    findAllCustomerAPI(findAllCustomerAPIInput: $val) {
      _id
      name
      dt
      hr
      usage_power
    }
  }
`
